export default __webpack_public_path__ + "static/media/LSVD-NRW.25c67075.mp4";